// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/app'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as TrendingRouteImport } from './routes/trending'
import { Route as FeedHandleRouteImport } from './routes/feed.$handle'
import { Route as ProfileHandleRouteImport } from './routes/profile.$handle'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const DocsRoute = DocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const LeaderboardRoute = LeaderboardRouteImport.update({
            id: '/leaderboard',path: '/leaderboard',getParentRoute: () => rootRouteImport
          })
const TrendingRoute = TrendingRouteImport.update({
            id: '/trending',path: '/trending',getParentRoute: () => rootRouteImport
          })
const FeedHandleRoute = FeedHandleRouteImport.update({
            id: '/feed/$handle',path: '/feed/$handle',getParentRoute: () => rootRouteImport
          })
const ProfileHandleRoute = ProfileHandleRouteImport.update({
            id: '/profile/$handle',path: '/profile/$handle',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRoute,DocsRoute: DocsRoute,LeaderboardRoute: LeaderboardRoute,TrendingRoute: TrendingRoute,FeedHandleRoute: FeedHandleRoute,ProfileHandleRoute: ProfileHandleRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)